import React from 'react'
import convertUnit from 'lib/unit'
import {RoboyuColorTheme} from '../../../types'
import {RoboyuAssetProps} from './RoboyuAssetProps'

export default function RoboyuOffer({
  width = convertUnit(519),
  height = convertUnit(673),
  colorTheme = 'blue',
  ...props
}: RoboyuAssetProps) {
  return (
    <svg
      {...props}
      width={width}
      height={height}
      viewBox="0 0 2000 2000"
      fill="none">
      <g filter="url(#filter0_d_4220_34186)">
        <path
          d="M990.65 1551.95C998.775 1415.2 1113.27 1360.45 1250.05 1368.58C1386.82 1376.7 1494.02 1444.63 1485.9 1581.38C1477.77 1718.13 1357.5 1870.18 1220.72 1862.05C1083.95 1853.93 982.5 1688.7 990.65 1551.95Z"
          fill="white"
        />
        <path
          d="M1458 1466.12C1436.03 1526.47 1363.53 1585.95 1184.13 1576.8C1075.78 1571.25 1022.05 1542.32 997.675 1507.62C993.841 1522.12 991.487 1536.98 990.65 1551.95C982.525 1688.7 1083.98 1853.93 1220.65 1861.95C1357.33 1869.98 1477.7 1718.02 1485.83 1581.27C1488.63 1535.25 1478.23 1496.95 1458 1466.12Z"
          fill="#98B1DC"
        />
        <path
          d="M1076.65 1572.2C1081.65 1487.75 1155.4 1462.35 1244.15 1467.62C1332.9 1472.9 1403.1 1506.85 1398.08 1591.3C1393.05 1675.75 1317.05 1740 1228.28 1734.7C1139.5 1729.4 1071.65 1656.67 1076.65 1572.2Z"
          fill="#BDE5EE"
        />
        <path
          d="M1076.83 1569.6C1081.83 1487.1 1155.4 1462.35 1244.15 1467.63C1332.9 1472.9 1403.15 1506.18 1398.25 1588.7C1393.35 1671.23 1317.4 1733.7 1228.65 1728.55C1139.9 1723.4 1071.93 1652.1 1076.83 1569.6Z"
          fill={RoboyuColorTheme[colorTheme].face_body_outline}
        />
        <path
          d="M1088.05 1571.6C1092.6 1494.88 1161.1 1471.9 1243.6 1476.8C1326.1 1481.7 1391.4 1512.65 1386.85 1589.3C1382.3 1665.95 1311.7 1724.3 1229.2 1719.3C1146.7 1714.3 1083.5 1648.3 1088.05 1571.6Z"
          fill={RoboyuColorTheme[colorTheme].face_body_2}
        />
        <path
          d="M1383.9 1556.05C1370.13 1503.55 1312.95 1481.05 1243.6 1476.8C1161.1 1471.8 1092.6 1494.87 1088.05 1571.6C1087.48 1581.17 1087.98 1590.78 1089.53 1600.25C1108.75 1609.57 1132.88 1617.42 1163.05 1623C1274.4 1643.65 1348.88 1605.85 1383.9 1556.05Z"
          fill={RoboyuColorTheme[colorTheme].face_body_1}
        />
        <path
          d="M1331.28 1555.37L1314.55 1554.37L1315.5 1538.25L1282.4 1536.3L1281.45 1552.4L1263.58 1551.35L1262.78 1565L1249.28 1564.2L1248.45 1578.2L1237.78 1577.55L1227.93 1576.97L1228.78 1562.67L1214.18 1561.8L1214.98 1548.2L1195.43 1547.05L1196.3 1532.12L1163.2 1530.15L1162.33 1545.07L1147.28 1544.17L1144.03 1598.77L1162.83 1599.9L1161.15 1628.37L1194.68 1630.35L1193.35 1652.62L1216.58 1654L1215.68 1669.05L1248.78 1671L1249.68 1655.97L1272.38 1657.3L1273.7 1635.05L1307.88 1637.1L1309.55 1608.87L1328.03 1609.97L1331.28 1555.37Z"
          fill={RoboyuColorTheme[colorTheme].heart_hair_2}
        />
        <path
          d="M1330.45 1555.33L1314.55 1554.38L1315.5 1538.28L1282.5 1536.3L1281.55 1552.4L1263.68 1551.35L1262.75 1565L1249.28 1564.18L1248.45 1578.18L1237.78 1577.53L1227.93 1576.95L1228.78 1562.65L1214.18 1561.78L1214.98 1548.18L1195.43 1547.03L1196.3 1532.03L1163.2 1530.05L1162.33 1545.05L1147.33 1544.15L1144.08 1598.75L1162.88 1599.88L1162.25 1610.5C1170.55 1612.88 1179.53 1615.08 1189.28 1617.05C1260.33 1631.45 1304.05 1596.48 1330.45 1555.33Z"
          fill={RoboyuColorTheme[colorTheme].heart_hair_1}
        />
        <path
          d="M1217.25 1846.1C1152.62 1841.77 1104.52 1814.55 1068.72 1777.88C1108.72 1825.38 1161.37 1858.52 1220.72 1862.05C1298.4 1866.65 1370.72 1819.55 1420.27 1753C1376.17 1807.5 1311.07 1852.35 1217.25 1846.1Z"
          fill="#BDE5EE"
        />
        <path
          d="M1798 1248.33C1748 1501.75 1533 1459.63 1268 1407.25C1003 1354.88 788.4 1312.08 838.525 1058.63C888.65 805.176 1144.03 642.226 1408.98 694.601C1673.93 746.976 1848.1 995.001 1798 1248.33Z"
          fill="white"
        />
        <path
          d="M1268.08 1407.25C1533.08 1459.75 1747.9 1501.75 1798.08 1248.32C1801.11 1232.94 1803.35 1217.41 1804.78 1201.8C1693.45 1286.62 1443.55 1391.62 1066.95 1270.65C952.575 1233.9 878.45 1191.22 831.95 1147.32C845.175 1323.32 1037.5 1361.67 1268.08 1407.25Z"
          fill="#98B1DC"
        />
        <path
          d="M1727.5 1223.3C1684.55 1440.5 1502.27 1404.75 1277.5 1360.33C1052.72 1315.9 870.4 1279.55 913.35 1062.5C956.3 845.451 1157.5 785.726 1382.17 830.176C1606.85 874.626 1770.32 1006.13 1727.5 1223.3Z"
          fill="#BDE5EE"
        />
        <path
          d="M1728 1220.17C1685.5 1435.17 1503.2 1399.45 1278.4 1355.02C1053.6 1310.6 871.45 1274.25 913.95 1059.25C956.45 844.25 1157.5 785.725 1382.17 830.175C1606.85 874.625 1770.5 1005.15 1728 1220.17Z"
          fill={RoboyuColorTheme[colorTheme].face_body_outline}
        />
        <path
          d="M1713.48 1219.05C1672.65 1425.52 1496.73 1391.05 1279.78 1348.15C1062.83 1305.25 887 1270.2 927.825 1063.72C968.65 857.249 1162.45 801.224 1379.43 844.124C1596.4 887.024 1754.3 1012.5 1713.48 1219.05Z"
          fill={RoboyuColorTheme[colorTheme].face_body_2}
        />
        <path
          d="M1720 1153.8C1718.9 985.927 1572.5 882.302 1379.52 844.127C1162.55 801.227 968.75 857.227 927.925 1063.73C924.793 1078.98 922.845 1094.45 922.1 1110C951.25 1165.23 1014.2 1218 1134 1256.8C1424.72 1351 1622.5 1249.85 1720 1153.8Z"
          fill={RoboyuColorTheme[colorTheme].face_body_1}
        />
        <path
          d="M1205.79 1076.38C1217.62 1016.54 1191.41 960.954 1147.25 952.227C1103.09 943.5 1057.71 984.937 1045.88 1044.78C1034.05 1104.62 1060.26 1160.21 1104.42 1168.94C1148.58 1177.66 1193.96 1136.23 1205.79 1076.38Z"
          fill={RoboyuColorTheme[colorTheme].eyes}
        />
        <path
          d="M1591.66 1152.67C1603.49 1092.83 1577.28 1037.24 1533.12 1028.52C1488.96 1019.79 1443.58 1061.23 1431.75 1121.07C1419.92 1180.91 1446.13 1236.5 1490.29 1245.22C1534.45 1253.95 1579.83 1212.51 1591.66 1152.67Z"
          fill={RoboyuColorTheme[colorTheme].eyes}
        />
        <path
          d="M950.55 1532.33C1001.1 1554.35 989.3 1387.88 983.575 1366.95C977.85 1346.03 704.175 1180.65 654.625 1198.73C605.075 1216.8 744.3 1442.5 950.55 1532.33Z"
          fill="white"
        />
        <path
          d="M654.625 1198.73C652.783 1199.38 651.101 1200.41 649.688 1201.76C648.274 1203.11 647.162 1204.74 646.425 1206.55C652.7 1248.23 824.5 1431.4 985.875 1488.3C992.525 1443.18 986.975 1379.38 983.575 1366.95C977.85 1346.03 704.175 1180.65 654.625 1198.73Z"
          fill="#98B1DC"
        />
        <path
          d="M972.3 1363.62C977.725 1368.32 987.3 1412.55 987.55 1473.75C991.375 1430.5 986.625 1378.1 983.575 1366.95C978.35 1347.87 750.425 1208.72 672.65 1198.02C745.425 1218.97 849.75 1271.5 972.3 1363.62Z"
          fill="#BDE5EE"
        />
        <path
          d="M746.375 1263.3C740.1 1274.15 719.35 1273.9 700 1262.72C680.65 1251.55 670 1233.7 676.3 1222.85C682.6 1212 703.325 1212.25 722.675 1223.4C742.025 1234.55 752.65 1252.5 746.375 1263.3Z"
          fill="#7BD3F7"
        />
        <path
          d="M1542.35 1522.5C1508.78 1502.25 1506.18 1642.07 1508.8 1659.77C1511.43 1677.47 1690.15 1825.67 1725.65 1812.27C1761.15 1798.87 1679.33 1605 1542.35 1522.5Z"
          fill="white"
        />
        <path
          d="M1524.35 1529.48C1514.65 1567.23 1540.68 1643.23 1548.2 1656.65C1556.65 1671.8 1664.27 1782.58 1729.07 1810C1728.11 1810.99 1726.94 1811.76 1725.65 1812.25C1690.15 1825.65 1511.4 1677.48 1508.8 1659.75C1506.75 1645.95 1507.87 1558.1 1524.35 1529.48Z"
          fill="#98B1DC"
        />
        <path
          d="M1508.8 1659.75C1507.81 1646.7 1507.7 1633.59 1508.45 1620.52C1509.6 1638.02 1511.75 1658.2 1513.72 1661.37C1520.37 1672.17 1622.85 1769 1697.97 1804.07C1705.97 1807.89 1714.35 1810.84 1722.97 1812.9C1682.1 1818.95 1511.35 1677.07 1508.8 1659.75Z"
          fill="#BDE5EE"
        />
        <path
          d="M1435.52 665.199C1435.52 665.199 1501.63 474.999 1519.28 477.299C1536.93 479.599 1596.78 535.349 1596.78 535.349C1596.78 535.349 1697.45 462.349 1699.28 470.049C1701.1 477.749 1640 654.549 1630.5 655.999C1621 657.449 1536.05 608.499 1536.05 608.499C1536.05 608.499 1426.85 686.824 1435.52 665.199Z"
          fill={RoboyuColorTheme[colorTheme].heart_hair_2}
        />
        <path
          d="M1596.72 535.349C1596.72 535.349 1536.95 479.599 1519.22 477.299C1501.5 474.999 1435.47 665.199 1435.47 665.199C1443.72 664.299 1535.17 562.049 1540.15 562.049C1545.12 562.049 1605.82 593.624 1610.82 592.799C1615.82 591.974 1699.25 469.999 1699.25 469.999C1697.5 462.349 1596.72 535.349 1596.72 535.349Z"
          fill={RoboyuColorTheme[colorTheme].heart_hair_1}
        />
        <path
          opacity="0.35"
          d="M373.425 617.523L979.15 528.773L1033.9 359.398L313.325 497.398L373.425 617.523Z"
          fill="#7BD3F7"
        />
        <path
          d="M676.3 1222.83L741.25 1264.8L792.65 1105.73L630.05 1130.4L676.3 1222.83Z"
          fill="#7BD3F7"
        />
        <path
          opacity="0.64"
          d="M516.8 904.048L859.875 897.798L923.8 700.023L439.725 750.023L516.8 904.048Z"
          fill="#7BD3F7"
        />
        <path
          opacity="0.16"
          d="M1033.9 359.398L1055.82 291.523C878.325 309.198 476.775 349.023 250.3 371.523L313.325 497.498L1033.9 359.398Z"
          fill="#7BD3F7"
        />
        <path
          opacity="0.45"
          d="M373.425 617.523L439.725 750.023L923.8 700.023L979.15 528.773L373.425 617.523Z"
          fill="#7BD3F7"
        />
        <path
          opacity="0.85"
          d="M630.05 1130.4L792.65 1105.73L859.875 897.801L516.8 904.051L630.05 1130.4Z"
          fill="#7BD3F7"
        />
        <path
          d="M324.425 379.148H216.45C203.223 379.148 192.5 389.871 192.5 403.098V567.473C192.5 580.701 203.223 591.423 216.45 591.423H324.425C337.652 591.423 348.375 580.701 348.375 567.473V403.098C348.375 389.871 337.652 379.148 324.425 379.148Z"
          fill="#B8E5FA"
        />
        <path
          d="M318.125 427.223H222.775C220.905 427.223 219.112 426.481 217.79 425.159C216.467 423.836 215.725 422.043 215.725 420.173V420.173C215.731 418.308 216.477 416.521 217.798 415.204C219.12 413.888 220.909 413.148 222.775 413.148H318.125C319.99 413.148 321.779 413.888 323.101 415.204C324.422 416.521 325.168 418.308 325.175 420.173V420.173C325.175 422.043 324.432 423.836 323.11 425.159C321.788 426.481 319.994 427.223 318.125 427.223V427.223Z"
          fill="#58CBF5"
        />
        <path
          d="M318.125 462.623H222.775C220.907 462.617 219.117 461.872 217.797 460.551C216.476 459.231 215.731 457.441 215.725 455.573V455.573C215.731 453.706 216.476 451.916 217.797 450.596C219.117 449.275 220.907 448.53 222.775 448.523H318.125C319.992 448.53 321.782 449.275 323.102 450.596C324.423 451.916 325.168 453.706 325.175 455.573C325.168 457.441 324.423 459.231 323.102 460.551C321.782 461.872 319.992 462.617 318.125 462.623Z"
          fill="#58CBF5"
        />
        <path
          d="M318.125 497.998H222.775C220.907 497.992 219.117 497.247 217.797 495.926C216.476 494.606 215.731 492.816 215.725 490.948C215.731 489.081 216.476 487.291 217.797 485.971C219.117 484.65 220.907 483.905 222.775 483.898H318.125C319.992 483.905 321.782 484.65 323.102 485.971C324.423 487.291 325.168 489.081 325.175 490.948V490.948C325.168 492.816 324.423 494.606 323.102 495.926C321.782 497.247 319.992 497.992 318.125 497.998V497.998Z"
          fill="#58CBF5"
        />
        <path
          d="M318.125 533.373H222.775C220.907 533.367 219.117 532.622 217.797 531.301C216.476 529.981 215.731 528.191 215.725 526.323C215.731 524.456 216.476 522.666 217.797 521.346C219.117 520.025 220.907 519.28 222.775 519.273H318.125C319.992 519.28 321.782 520.025 323.102 521.346C324.423 522.666 325.168 524.456 325.175 526.323V526.323C325.168 528.191 324.423 529.981 323.102 531.301C321.782 532.622 319.992 533.367 318.125 533.373V533.373Z"
          fill="#58CBF5"
        />
        <path
          d="M972.775 137.5H894.95C885.423 137.5 877.7 145.223 877.7 154.75V273.225C877.7 282.752 885.423 290.475 894.95 290.475H972.775C982.302 290.475 990.025 282.752 990.025 273.225V154.75C990.025 145.223 982.302 137.5 972.775 137.5Z"
          fill="#B8E5FA"
        />
        <path
          d="M968.225 172.148H899.525C898.199 172.148 896.928 171.622 895.99 170.684C895.052 169.746 894.525 168.475 894.525 167.148C894.525 165.822 895.052 164.551 895.99 163.613C896.928 162.675 898.199 162.148 899.525 162.148H968.225C969.551 162.148 970.823 162.675 971.761 163.613C972.699 164.551 973.225 165.822 973.225 167.148C973.225 168.475 972.699 169.746 971.761 170.684C970.823 171.622 969.551 172.148 968.225 172.148Z"
          fill="#58CBF5"
        />
        <path
          d="M968.225 197.648H899.525C898.199 197.648 896.928 197.122 895.99 196.184C895.052 195.246 894.525 193.975 894.525 192.648C894.525 191.322 895.052 190.051 895.99 189.113C896.928 188.175 898.199 187.648 899.525 187.648H968.225C969.551 187.648 970.823 188.175 971.761 189.113C972.699 190.051 973.225 191.322 973.225 192.648C973.225 193.975 972.699 195.246 971.761 196.184C970.823 197.122 969.551 197.648 968.225 197.648Z"
          fill="#58CBF5"
        />
        <path
          d="M968.225 223.148H899.525C898.199 223.148 896.928 222.622 895.99 221.684C895.052 220.746 894.525 219.475 894.525 218.148C894.525 216.822 895.052 215.551 895.99 214.613C896.928 213.675 898.199 213.148 899.525 213.148H968.225C969.551 213.148 970.823 213.675 971.761 214.613C972.699 215.551 973.225 216.822 973.225 218.148C973.225 219.475 972.699 220.746 971.761 221.684C970.823 222.622 969.551 223.148 968.225 223.148Z"
          fill="#58CBF5"
        />
        <path
          d="M968.225 248.648H899.525C898.199 248.648 896.928 248.122 895.99 247.184C895.052 246.246 894.525 244.975 894.525 243.648C894.525 242.322 895.052 241.051 895.99 240.113C896.928 239.175 898.199 238.648 899.525 238.648H968.225C969.551 238.648 970.823 239.175 971.761 240.113C972.699 241.051 973.225 242.322 973.225 243.648C973.225 244.975 972.699 246.246 971.761 247.184C970.823 248.122 969.551 248.648 968.225 248.648Z"
          fill="#58CBF5"
        />
        <path
          d="M981.9 583.648H946.275C939.123 583.648 933.325 589.446 933.325 596.598V637.198C933.325 644.351 939.123 650.148 946.275 650.148H981.9C989.052 650.148 994.85 644.351 994.85 637.198V596.598C994.85 589.446 989.052 583.648 981.9 583.648Z"
          fill="white"
        />
        <path
          d="M628.925 1101.88H614.375C611.461 1101.88 609.1 1104.24 609.1 1107.15V1123.75C609.1 1126.66 611.461 1129.02 614.375 1129.02H628.925C631.838 1129.02 634.2 1126.66 634.2 1123.75V1107.15C634.2 1104.24 631.838 1101.88 628.925 1101.88Z"
          fill="white"
        />
        <path
          d="M424.4 777.949H409.85C406.937 777.949 404.575 780.311 404.575 783.224V799.824C404.575 802.738 406.937 805.099 409.85 805.099H424.4C427.314 805.099 429.675 802.738 429.675 799.824V783.224C429.675 780.311 427.314 777.949 424.4 777.949Z"
          fill="white"
        />
        <path
          d="M1023.73 528.523H1009.18C1006.26 528.523 1003.9 530.885 1003.9 533.798V550.398C1003.9 553.312 1006.26 555.673 1009.18 555.673H1023.73C1026.64 555.673 1029 553.312 1029 550.398V533.798C1029 530.885 1026.64 528.523 1023.73 528.523Z"
          fill="white"
        />
        <path
          d="M842.5 644.898H827.95C825.036 644.898 822.675 647.26 822.675 650.173V666.773C822.675 669.687 825.036 672.048 827.95 672.048H842.5C845.413 672.048 847.775 669.687 847.775 666.773V650.173C847.775 647.26 845.413 644.898 842.5 644.898Z"
          fill="white"
        />
        <path
          d="M555.6 234.25H541.05C538.137 234.25 535.775 236.612 535.775 239.525V256.125C535.775 259.038 538.137 261.4 541.05 261.4H555.6C558.514 261.4 560.875 259.038 560.875 256.125V239.525C560.875 236.612 558.514 234.25 555.6 234.25Z"
          fill="white"
        />
        <path
          d="M504.7 163H469.075C461.923 163 456.125 168.798 456.125 175.95V216.55C456.125 223.702 461.923 229.5 469.075 229.5H504.7C511.852 229.5 517.65 223.702 517.65 216.55V175.95C517.65 168.798 511.852 163 504.7 163Z"
          fill="white"
        />
        <path
          d="M368.35 713.352H332.725C325.573 713.352 319.775 719.149 319.775 726.302V766.902C319.775 774.054 325.573 779.852 332.725 779.852H368.35C375.502 779.852 381.3 774.054 381.3 766.902V726.302C381.3 719.149 375.502 713.352 368.35 713.352Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4220_34186"
          x="152.5"
          y="101.5"
          width="1694.09"
          height="1804.86"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="20" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.3375 0 0 0 0 0.3375 0 0 0 0 0.3375 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4220_34186"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4220_34186"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
